// extracted by mini-css-extract-plugin
export default {"resultText":"ResultBlock_resultText__XzoWj","questionButtons":"ResultBlock_questionButtons__g683k"};